import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { CountUp } from 'countup.js';
import Alpine from 'alpinejs';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

interface RankingStripComponent extends InitSwiperComponent {

  instanceCountUp(elements: HTMLElement[]): void;
}

export default function initRankingStrip() {
  Alpine.data(
    'rankingStrip',
    (): RankingStripComponent => ({
      swiper: null,
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          // @ts-ignore
          const rankingStrip = this.$el;
          const rankingStripNumbers = rankingStrip.querySelectorAll('.count-up-number');

          const observer = new IntersectionObserver(
            (entries, observerInstance) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
                  this.instanceCountUp(rankingStripNumbers);
                  observerInstance.unobserve(entry.target);
                }
              });
            },
            {
              threshold: 0.7,
            },
          );

          observer.observe(rankingStrip);

          const swiperEl = rankingStrip.querySelector('.ranking-strip-swiper');
          if (swiperEl) {
            this.initSwiper(swiperEl);
          }
        });
      },
      instanceCountUp(elements: HTMLElement[]) {
        elements.forEach((numberEl) => {
          const { value } = numberEl.dataset;
          const getValue = parseInt(value ?? '0', 10);
          if (getValue > 0) {
            const countUpInstance = new CountUp(numberEl, getValue, {
              duration: 4,
              useEasing: true,
            });
            countUpInstance.start();
          }
        });
      },
      initSwiper(domEl: HTMLElement) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 2,
          spaceBetween: 30,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .ranking-strip__buttons .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .ranking-strip__buttons .swiper-button-prev`,
          },
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 30,
              centeredSlides: true,
            },
            992: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 5,
            },
          },
        });
      },
    }),
  );
}
